module.exports = __webpack_public_path__ + "static/img/TMBcharacterPhotos_0001_shadowMoon.2224e40.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/TMBcharacterPhotos_0001_shadowMoon.jpg
// module id = 8h3M
// module chunks = 1